/* SoleGuard theme scripts */
(function () {
  'use strict';

  /* ---- Mobile nav toggle ---- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-site-nav]');
      if (nav) nav.classList.toggle('is-open');
    }
  });
  /* ---- Hauntistry: no collection page, send shoppers to the product picker ---- */ (function () { var P = /^\/collections(\/|$)/; if (P.test(location.pathname)) { location.replace('/#shop'); return; } function fixLinks() { var home = location.pathname === '/'; document.querySelectorAll('a[href]').forEach(function (a) { var h = a.getAttribute('href').split('?')[0]; if (P.test(h) && h.indexOf('/products/') === -1) { a.setAttribute('href', home ? '#shop' : '/#shop'); } }); } if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fixLinks); } else { fixLinks(); } })(); window.addEventListener('load', function () { if (location.hash === '#shop') { var s = document.getElementById('shop'); if (s) { setTimeout(function () { s.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 150); } } });
  /* ---- FAQ accordion ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.faq__question');
    if (!btn) return;
    var item = btn.closest('.faq__item');
    var answer = item.querySelector('.faq__answer');
    var isOpen = item.classList.toggle('is-open');
    if (isOpen) {
      answer.style.maxHeight = answer.scrollHeight + 'px';
    } else {
      answer.style.maxHeight = null;
    }
  });

  /* ---- Product gallery thumbnails ---- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.product__thumb');
    if (!thumb) return;
    var gallery = thumb.closest('[data-product-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main-img]');
    var full = thumb.getAttribute('data-full');
    if (main && full) main.src = full;
    gallery.querySelectorAll('.product__thumb').forEach(function (t) {
      t.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
  });

  /* ---- Product details accordion (reuses faq behavior already) ---- */

  /* ---- Variant selection -> update form & price ---- */
  document.querySelectorAll('#product-form, form[action$="/cart/add"]').forEach(function (form) {
    var variantsData = form.querySelector('[data-variants-json]');
    if (!variantsData) return;
    var variants;
    try { variants = JSON.parse(variantsData.textContent); } catch (err) { return; }

    function getSelectedOptions() {
      var opts = [];
      form.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) opts[parseInt(group.getAttribute('data-option-index'), 10)] = checked.value;
      });
      return opts;
    }

    function updateVariant() {
      var selected = getSelectedOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
      var idInput = form.querySelector('[name="id"]');
      var priceEl = form.querySelector('[data-product-price]');
      var addBtn = form.querySelector('[data-add-to-cart]');
      if (match) {
        if (idInput) idInput.value = match.id;
        if (priceEl && match.price_formatted) priceEl.textContent = match.price_formatted;
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? addBtn.getAttribute('data-add-label') : 'Sold out';
        }
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) updateVariant();
    });
    updateVariant();
  });
})();
